import { __awaiter } from "tslib";
import { PrescriptionPadService } from "@/servicesTs/models/general/prescriptionPad";
const modulePrescriptionPad = {
    namespaced: true,
    state: {
        loading: false,
        prescriptionPad: {
            data: [],
            total: 0,
            per_page: 0,
            current_page: 1,
        },
    },
    getters: {
        getLoading(state) {
            return state.loading;
        },
        getPrescriptionPad(state) {
            return state.prescriptionPad;
        },
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setPrescriptionPad(state, data) {
            state.prescriptionPad = data;
        },
        setPagePrescriptionPad(state, page) {
            state.prescriptionPad.current_page = page;
        },
    },
    actions: {
        getPrescriptionPad({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const PRESCRIPTION_PAD = yield PrescriptionPadService.getIndex({ page: state.prescriptionPad.current_page });
                commit("setPrescriptionPad", PRESCRIPTION_PAD);
                commit("setLoading", false);
            });
        },
    },
};
export default modulePrescriptionPad;
